















import Vue, { PropType } from 'vue';
import { MaintenanceList } from '@/types';

export default Vue.extend({
  props: {
    checklist: {
      type: Object as PropType<MaintenanceList>,
      required: true
    }
  }
});
